import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function MainLayout() {
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [loc.pathname]);
  return (
    <Stack
      sx={{
        minHeight: "100svh",
      }}
    >
      <Navbar />
      <Outlet />
      <Footer />
    </Stack>
  );
}
